import jsonp from 'jsonp';

export default {
    serverName: 'https://api.start.ru/',
    apiKey: '166f76a82add457bb732703f7feeb2b1',
    authToken: null,
    deviceId: null,
    profileId: null,

//     Можно запускать 1 раз для получения данных для запросов
// profile_id - нужен для работы с избранными
// authentication_token - auth_token нужен для всех запросов
// devices[0].uid - deviceId нужен для получения стима
    authKartina(kartinaId, apiKey, callback) {
        let body = {kartina_id: kartinaId};
        let url = this.serverName + 'auth/kartina?apikey=' + apiKey;

        fetch(url, {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(body),
        })
            .then(res => {
                callback(null, res);
            })
            .catch(error => {
                callback(error);
            });
    },

    setApiKey(apiKey) {
        this.apiKey = apiKey;
    },
    setToken(authToken) {
        this.authToken = authToken;
    },
    setDeviceId(deviceId) {
        this.deviceId = deviceId;
    },
    setProfileId(profileId) {
        this.profileId = profileId;
    },

    getMainList(callback) {
        jsonp(this.serverName +  `web/main?apikey=${this.apiKey}&auth_token=${this.authToken}`, null, callback);
    },
    getGenresList(callback) {
        jsonp(this.serverName +  `web/genres?apikey=${this.apiKey}&auth_token=${this.authToken}`, null, callback);
    },
    getMovies(callback) {
        jsonp(this.serverName +  `web/movies?apikey=${this.apiKey}&auth_token=${this.authToken}`, null, callback);
    },
    getSeries(callback) {
        jsonp(this.serverName +  `web/series?apikey=${this.apiKey}&auth_token=${this.authToken}`, null, callback);
    },

    getFavorites(callback) {
        jsonp(this.serverName +  `profile/favorites/${this.profileId}?apikey=${this.apiKey}&auth_token=${this.authToken}`, null, callback);
    },

    getGenreItem(genreId, callback) {
        jsonp(this.serverName +  `web/genres/${genreId}?apikey=${this.apiKey}&auth_token=${this.authToken}`, null, callback);
    },
    getMovieItem(alias, callback) {
        jsonp(this.serverName +  `web/movie/${alias}?apikey=${this.apiKey}&auth_token=${this.authToken}`, null, callback);
    },
    getSeriesItem(alias, callback) {
        jsonp(this.serverName +  `web/series/${alias}?apikey=${this.apiKey}&auth_token=${this.authToken}`, null, callback);
    },
    getSeriesSeason(alias, callback) {
        jsonp(this.serverName +  `web/series/season/${alias}?apikey=${this.apiKey}&auth_token=${this.authToken}`, null, callback);
    },

    search(query, callback) {
        let limit = 10;

        jsonp(this.serverName +  `web/search?apikey=${this.apiKey}&auth_token=${this.authToken}&limit=${limit}&query=${query}`, null, callback);
    },

    getStreamUrl(playbackOptions, callback) {
        jsonp(this.serverName +  `${playbackOptions}?apikey=${this.apiKey}&auth_token=${this.authToken}&device_id=${this.deviceId}`, null, callback);
    },

    addToFavorites(productId, callback) {
        let body = {product_id: productId};
        let url = this.serverName + `profile/favorites/${this.profileId}?apikey=${this.apiKey}&auth_token=${this.authToken}`;

        fetch(url, {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(body),
        })
            .then(res => {
                callback(null, res);
            })
            .catch(error => {
                callback(error);
            });
    }
}


// WEBPACK FOOTER //
// ./src/libs/start.js